import React, { useState, useEffect, useRef } from "react";
export const useDate = () => {
  const locale = 'en-us';
  const [today, setDate] = React.useState(new Date()); // Save the current date to be able to trigger an update

  React.useEffect(() => {
      const timer = setInterval(() => { // Creates an interval which will update the current data every minute
      // This will trigger a rerender every component that uses the useDate hook.
      setDate(new Date());
    }, 60 * 1000);
    return () => {
      clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
    }
  }, []);
  const day = today.toLocaleDateString(locale, { weekday: 'long',timeZone: 'America/New_York' });
  const year = today.getFullYear();
  const date = `${day}, ${today.toLocaleDateString(locale, { month: 'long',timeZone: 'America/New_York' })} ${today.getDate()} ${year}\n\n`;

  const hour = today.getHours();

  const time = today.toLocaleTimeString(locale, { hour: 'numeric', hour12: true, minute: 'numeric',timeZone: 'America/New_York' });

  const monthDate = `${today.toLocaleDateString(locale, { month: 'long',timeZone: 'America/New_York' })} ${today.getDate()}\n\n`; 

  return {
    date,
    time,
    monthDate,
    year
  };
};